import { useEffect, useState } from "react";
import { useSelector,useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { MotifModal, MotifModalBody, MotifModalFooter, MotifModalHeader, MotifButton } from '@ey-xd/motif-react';
import MotifTooltip from '@ey-xd/motif-react/Tooltip';
import EditPersonalPrompt from '../../forms/editPersonalPrompt/EditPersonalPrompt';
import "./AddPersonalPrompt.scss";
import PromptLibraryService from "../../../../services/promptLibraryService";
import { setReferences } from "../../../../redux/promptSlice";

function AddPersonalPrompt({showAddPersonalModal, handleCloseAddPersonalPromptModal, handleConfirmAddPersonalPromptModal}) {
    const [tableTypeRefs, setTableTypeRefs] = useState([]);
    const promptLibraryService = new PromptLibraryService();
    const { newPersonalPrompt, isValidationErrorOnAddNewPrompt } = useSelector(state => state.prompt);
    const [disableConfirmButton, setDisableConfirmButton] = useState(true);
     const dispatch = useDispatch();
    /**
     * Hook to populate table type references
     */
    useEffect(() => {
        const getReferences = async () => {
            const vPayload = {
                ProjectScopeId: "",
                Type: "A",
                application: "EXL_AddIn",
                PromptType: "Central"
            };
            const response = await promptLibraryService.getTableTypes(vPayload);
            if (response?.length > 0) {
                const vTableTypeRefs = response.map((element) => ({
                    ReferenceKey: element.api,
                    ReferenceValue: element.api,
                    isPublished: element.isPublished
                }));
                dispatch(setReferences(vTableTypeRefs));
                setTableTypeRefs(vTableTypeRefs);
            }
        };
        getReferences();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        //Validate newPersonalPrompt for button enable/disable
        const tableType = newPersonalPrompt.tableType;
        const promptName = newPersonalPrompt.promptName;
        const prompts = newPersonalPrompt.prompts;
        if(
            (tableType && tableType.length > 0) &&
            (promptName && promptName.trim().length > 0) &&
            (prompts.every((p) => p.promptBody?.trim()?.length > 0))
        ){
            setDisableConfirmButton(false);
        } else {
            setDisableConfirmButton(true);
        }
    }, [newPersonalPrompt])

    return(
        <MotifModal id="addPersonalPromptModal" 
            show={showAddPersonalModal} 
            size="md"
            focusTrapOptions={{
                tabbableOptions: {
                    displayCheck: 'none',
                },
            }}
            onClose={handleCloseAddPersonalPromptModal}
            className="addPersonalPromptModal genericModal modalMotifFooterModal"
        >
            <MotifModalHeader
                closeButtonProps={{
                    'aria-label': 'Close',
                    title: 'Close'
                }}
                className="addPersonalPromptHeader"
            >
                <div>Add New Prompt</div>
            </MotifModalHeader>
            <MotifModalBody className="addPersonalPromptBody">
                <EditPersonalPrompt 
                    personalPrompt={newPersonalPrompt}
                    setShowEditPersonalPrompt={()=>{}}
                    handlePromptSave={()=>{}}
                    useAsAddPersonalPrompt={showAddPersonalModal}
                    tableTypeRefs={tableTypeRefs} />
            </MotifModalBody>
            <MotifModalFooter className="motif-modal-footer">
                <MotifButton
                    label="btnCancel"
                    size="small"
                    type="button"
                    variant="secondary"
                    className="btnCancel"
                    onClick={handleCloseAddPersonalPromptModal}
                >
                    Cancel
                </MotifButton>
                <MotifTooltip
                    hide={!(isValidationErrorOnAddNewPrompt || disableConfirmButton)}
                    contentClassName="tooltipWithoutCloseCenterText"
                    trigger={
                        <MotifButton
                            label="btnConfirm"
                            size="small"
                            type="button"
                            variant="primary"
                            className="btnConfirm"
                            disabled={isValidationErrorOnAddNewPrompt || disableConfirmButton}
                            onClick={() => { setDisableConfirmButton(true); handleConfirmAddPersonalPromptModal(); }}
                        >
                            Confirm
                        </MotifButton>
                    }
                    placement="top"
                    allowClick={false}
                    hideCloseButton={true}
                >
                    Complete all <br/>inputs to continue
                </MotifTooltip>
            </MotifModalFooter>
        </MotifModal>
    );
}

AddPersonalPrompt.propTypes = {
    showAddPersonalModal: PropTypes.bool,
    handleCloseAddPersonalPromptModal: PropTypes.func,
    handleConfirmAddPersonalPromptModal: PropTypes.func
}

export default AddPersonalPrompt;